// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tags_wrapper__PR_ja","container":"Tags_container__sdNsQ","button":"Tags_button__KE4Oe","inactive":"Tags_inactive__nPebx"};